<template>
  <div
    :class="cardClasses"
    role="button"
    :aria-disabled="!limiter.enabled"
    :data-testid="`limiter-card-${limiter.type}`"
    @click="handleClick">
    <div>
      <div class="font-weight-bold">
        {{ limiter.title }}
      </div>
      <div v-if="limiter.subtitle" class="font-weight-light font-size-small d-block">
        {{ limiter.subtitle }}
      </div>
    </div>

    <div>
      <v-btn variant="flat" :data-testid="`limiter-manage-btn-${limiter.type}`">
        {{ t('unitLimiter.limiterCard.manage') }}
        <v-icon v-if="limiter.showIcon" size="small" class="ml-2">mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  limiter: {
    type: Object,
    required: true,
    validator: limiter => {
      return (
        typeof limiter.title === 'string' &&
        typeof limiter.enabled === 'boolean' &&
        typeof limiter.onClick === 'function'
      );
    }
  }
});

const emit = defineEmits(['click']);

const cardClasses = computed(() => [
  'border border-radius d-flex justify-space-between align-center font-weight-bold pa-3 pl-5 mb-3',
  {
    'cursor-pointer': props.limiter.enabled,
    'cursor-not-allowed opacity-50': !props.limiter.enabled
  }
]);

const handleClick = () => {
  if (props.limiter.enabled) {
    emit('click');
  }
};
</script>

<style scoped lang="scss"></style>
